// extracted by mini-css-extract-plugin
export default {"wrap":"StarRate_wrap__Di9hD","star_icon":"StarRate_star_icon__4HNOz"};